import * as d3 from 'd3'
export default {
  methods: {

    draw_Header(newHeaders) {
      let bg = this.header.background

      let head = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.header.x}, ${this.header.y})`)
      
      if(bg.visible == 'Y') {
        head
        .append('rect')
        .attr('x', 0).attr('y', bg.padding)
        .attr('width', this.header.width).attr('height', this.header.height - (bg.padding*2))
        .attr('fill', (bg.color.substr(0,1)=='#') ? bg.color : `url(#${this.localId}_${bg.color}_)`)
        .attr('opacity', bg.opacity)
      }

      newHeaders.forEach((row,r)=> {

        row.forEach((col,c)=> {
          if(col.name == '-' || col.name == '+') return
          
          if(bg.visible != 'Y' && col.bColor) {
            head
            .append('rect')
            .attr('x', col.sx).attr('y', col.sy)
            .attr('width', col.ex - col.sx).attr('height', col.ey - col.sy)
            .attr('fill', (col.bColor.substr(0,1)=='#') ? col.bColor : `url(#${this.localId}_${col.bColor}_)`)
            .attr('opacity', col.opacity)
          }

          if(newHeaders[r][c].name.substr(0,1) == '#') {
            head
            .append('g')
            .attr('id', `WRAP_${r}_${c}_${this.localId}`)
            .attr('transform', `translate(${col.mx}, 0)`)

            this.gmx_wrapText(
              {
                text: newHeaders[r][c].name.substr(1),
                wSize: col.ex - col.sx - 4, // Wrap Width
                lineHeight: 13,
                parents: `#WRAP_${r}_${c}_${this.localId}`, 
                tColor: col.tColor, 
                tSize: col.tSize, 
                align: 'middle',
              },
            )
            d3.select(`#WRAP_${r}_${c}_${this.localId}`)
            .attr('transform', `translate(${col.mx}, ${col.my - (this.getNode(`#WRAP_${r}_${c}_${this.localId}`, 'height')/2) + 13})`)

          } else {
            head
            .append('text')
            .attr('x', col.mx).attr('y', col.my + col.tSize*0.36)
            .attr('font-size', col.tSize).attr('fill', col.tColor)
            .attr('text-anchor', 'middle')
            .text(newHeaders[r][c].name)
          }
          
          head
          .append('line') // Horizontal Line
          .attr('x1', col.sx).attr('x2', col.ex).attr('y1', col.sy).attr('y2',col.sy)
          .attr('stroke', col.hStroke).attr('stroke-width', (this.header.exxon == 'Y' && r==0) ? 1 : .5)

          if(this.header.lineFL != 'Y' && c == 0) {
            //
          } else if(this.header.exxon != 'Y') {
            head
            .append('line') // Vertical Line
            .attr('x1', col.sx).attr('x2', col.sx).attr('y1', col.sy).attr('y2',col.ey)
            .attr('stroke', col.vStroke).attr('stroke-width', .5)
          }

          
        })

      })

    },
  }
}